import { Card, CardBody, Col } from "reactstrap";
import { SingleFileuploadTitle } from "../../../Constants/Constants";
import { FileUploadData } from "../../../Data/BonusUi/Dropzone";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonFileUpload from "../../CommonComponents/CommonFileUpload";

const SingleFileupload = () => {
  return (
    <Col lg="6">
      <Card className="single-dropzone">
        <CommonCardHeader title={SingleFileuploadTitle} span={FileUploadData} />
        <CardBody>
          <CommonFileUpload />
        </CardBody>
      </Card>
    </Col>
  );
};
export default SingleFileupload;
